import { getSliceContent } from './content';
import get from '../helpers/get';

export const getSliceClickthroughBanner1 = (state, sliceId) => get(getSliceContent(state, sliceId), ['banner_1_clickthrough']);

export const getSliceClickthroughBanner2 = (state, sliceId) => get(getSliceContent(state, sliceId), ['banner_2_clickthrough']);
